module.exports = __webpack_public_path__ + "public/SiteIcons/viewIcon.svg?31ba2458";